import { render, staticRenderFns } from "./ItemTable.vue?vue&type=template&id=ebb98152&scoped=true"
import script from "./ItemTable.vue?vue&type=script&lang=js"
export * from "./ItemTable.vue?vue&type=script&lang=js"
import style0 from "./ItemTable.vue?vue&type=style&index=0&id=ebb98152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb98152",
  null
  
)

export default component.exports